import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=1cedf218"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VImg,VOverlay,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cedf218')) {
      api.createRecord('1cedf218', component.options)
    } else {
      api.reload('1cedf218', component.options)
    }
    module.hot.accept("./Administration.vue?vue&type=template&id=1cedf218", function () {
      api.rerender('1cedf218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administration.vue"
export default component.exports